import { useEffect, useState } from 'react';

/** The current time, refreshed every `everyMs` (relative times like «aggiornato 12 s fa»). */
export function useNow(everyMs = 10_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), everyMs);
    return () => clearInterval(timer);
  }, [everyMs]);
  return now;
}
